export const form = {
    name: 'Nombre',
    email: 'E-mail',
    phone: 'Telefono',
    state: 'Estado',
    city: 'Ciudad',
    zipcode: 'Código postal',
    uf: 'UF',
    role: 'Tu papel en el trabajo',
    required: 'Obligatorio',
    invalid: 'Inválido',
    newsletter: 'Deseo recibir novedades de Castelatto por e-mail',
    button: 'Buscar Reventas',
    error: 'Uno o más campos contienen errores. Inténtalo de nuevo.',
    request_error: 'Lo sentimos, hubo un error con su solicitud. Inténtalo de nuevo.',
    success: 'Espere. Estamos realizando su búsqueda.',
    professional: 'Especificación profesional (arquitecto, diseñador de interiores, arquitecto paisajista, ingeniero, etc.)',
    builder: 'Constructora, Desarrolladora, Ingeniería',
    consumer: 'Consumidor final',
    others: 'Otros',
    call: 'Llamada telefónica',
    header: 'Llene el formulario y hable con nuestro<br> departamento de comercio exterior',
    alert: '* Todos los campos son obligatorios',
};

export const result = {
    no_results: 'Gracias por su interés en los productos CASTELATTO. En breve recibirá un correo electrónico',
    engineering_results: "Para una atención personalizada, espere el contacto de nuestro equipo de Ingeniería.",
    title: 'Resultado de búsqueda',
    result: 'Reventa cerca de ti',
    thanks: 'Gracias por su interés en los productos CASTELATTO. Vea a continuación las tiendas más cercanas a CEP: {zipcode}',
    address: 'Dirección',
    phone: 'Teléfono',
    zipcode: 'Código postal',
    email: 'Email',
    city: 'Ciudad',
    distance: 'Distancia',
    how_to_get: 'Cómo llegar',
    button: 'VOLVER',
    print: 'Imprimir',
    send: 'Enviar por email',
    innovation: 'Innovacion',
    architecture: 'Arquitectura',
    design: 'Diseño',
    success: 'Email enviado con éxito',
    error: 'Hubo un error al enviar su correo electrónico. :/',
};
